import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import { CursoContext } from '../../context/CursoContext';
import { CursoType, CreateCursoType, EditCursoType } from '../../context/hooks/useCurso';
import { InstituicaoContext } from '../../context/InstituicaoContext';
import { InstituicaoType, CreateInstituicaoType, EditInstituicaoType } from '../../context/hooks/useInstituicao';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateCursoModal } from '../../components/Curso/CreateCursoModal';
import { EditCursoModal } from '../../components/Curso/EditCursoModal';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const Curso = () => {
    const { objUserTk } = useContext(AuthContext);
    const { createCurso, getCursoPaged, updateCurso, deleteCurso, listCurso, pageCount } = useContext(CursoContext);
    const { handleGetInstituicaoByEmpresaId, listInstituicao } = useContext(InstituicaoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [loaging, setLoading] = useState(true);
    const [newCurso, setNewCurso] = useState<CreateCursoType>({
        name: '', empresaId: objUserTk.EmpresaId
    });
    const [editingCurso, setEditingCurso] = useState<EditCursoType | null>(null);
    const [dataSearch, setDataSearch] = useState({ name: '' });
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        setLoading(true);

        handleGetInstituicaoByEmpresaId(objUserTk.EmpresaId);

        getCursoPaged(1, "", objUserTk.EmpresaId, 9)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar cursos:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getCursoPaged(value, dataSearch.name, objUserTk.EmpresaId, 9);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, name: e.target.value });
    };

    const handleSearchButtonClick = () => {
        setLoading(true);
        getCursoPaged(1, dataSearch.name, objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleClearFilters = () => {
        setDataSearch({ name: '' });
        setLoading(true);
        getCursoPaged(1, "", objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleEditCurso = (curso: CursoType) => {
        const updateData: EditCursoType = {
            id: curso.id,
            name: curso.name,
        };
        setEditingCurso(updateData);
        setEditModalOpen(true);
    };

    const [confirmDeleteCursoId, setConfirmDeleteCursoId] = useState<number | null>(null);

    const handleDeleteCurso = (cursoId: number) => {
        setConfirmDeleteCursoId(cursoId);
    };

    const executeDeleteCurso = () => {
        if (confirmDeleteCursoId == null) return;
        deleteCurso(confirmDeleteCursoId)
            .then(() => {
                setTimeout(() => {
                    getCursoPaged(1, "", objUserTk.EmpresaId, 9);
                }, 500);
            })
            .catch(error => console.error("Erro ao excluir curso:", error));
        setConfirmDeleteCursoId(null);
    };
    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar Cursos"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="search"
                            id="search"
                            placeholder="Buscar por nome"
                            value={dataSearch.name}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearchButtonClick}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.InstituicoesCursos, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                size="m"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar curso
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.InstituicoesCursos, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listCurso.map((curso: CursoType, index: number) => (
                                        <tr key={index}>
                                            <td>{curso.name}</td>
                                            <td>
                                                {hasPermission(PermissionModule.InstituicoesCursos, 3) && (
                                                    <Button onClick={() => handleEditCurso(curso)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                )}
                                                {hasPermission(PermissionModule.InstituicoesCursos, 4) && (
                                                    <Button onClick={() => handleDeleteCurso(curso.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount > 0 ? (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                ) : null}
                                {listCurso.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os cursos.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateCursoModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCursoCriado={() => getCursoPaged(1, dataSearch.name, objUserTk.EmpresaId, 9)}
            />

            {editingCurso && (
                <EditCursoModal
                    isOpen={editModalOpen}
                    toggle={() => setEditModalOpen(false)}
                    cursoData={editingCurso}
                    onCursoAtualizado={() => getCursoPaged(1, dataSearch.name, objUserTk.EmpresaId, 9)}
                />
            )}

            <ModalConfirm
                openModal={confirmDeleteCursoId !== null}
                closeModal={() => setConfirmDeleteCursoId(null)}
                handleConfirm={executeDeleteCurso}
                title="Excluir curso"
                message="Tem certeza que deseja excluir este curso? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default Curso;